module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "euroe.91b1e510.png";